import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

const AuthContext = createContext({ user: null, setUser: () => {}, logout: () => {} });
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const isAdmin = useLocation().pathname.startsWith("/admin");

  useEffect(() => {
    if (!isAdmin || user !== null) return;
    api.get("/api/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, [isAdmin, user]);

  const logout = async () => {
    try { await api.post("/api/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
